import { logAndNotifyError } from "../modules/logger";
import Notify from "devextreme/ui/notify";

// @import url("../node_modules/ace-builds/css/ace.css");
// @import url("../node_modules/ace-builds/css/theme/dreamweaver.css");
// @import url("../node_modules/ace-builds/css/theme/ambiance.css");
// @import url("../node_modules/devextreme/dist/css/dx.carmine.css");
import { ChangeEventHandler, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { get, getUserInfo, post } from "../modules/server";
import { Alert, Button, Card, Row } from "react-bootstrap";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import { EventInfo } from "devextreme/events";
import { DataGrid, List } from "devextreme-react";
import { OptionChangedEventInfo } from "devextreme/core/dom_component";

import ArrayStore from "devextreme/data/array_store";
import dxDataGrid, { EditingStartEvent, NewRowInfo, RowDblClickEvent } from "devextreme/ui/data_grid";
import { Column, Editing, Form, Popup } from "devextreme-react/data-grid";
import { useForm } from "react-hook-form";
import ValidationSummaryMessages from "../components/Configuration/ValidationSummaryMessages";
import TextEditor from "../components/Global/Editors/TextEditor";
import { useNavigate } from "react-router-dom";
import { getRoleName } from "../modules/common";
import StaticBox from "../components/Global/StaticBox";
import { useGlobalData } from "../components/GlobalDataProvider";

const UserProfile = () => {
  const formHook = useForm({ defaultValues: {} });
  const navigate = useNavigate();
  const globalData = useGlobalData();

  useEffect(() => {
    (async () => {
      const response = await get("GetUserProfile");
      if (response.success) {
        formHook.reset(response.profile);
      } else {
        Notify(response.message, "error");
      }
    })();
  }, []);

  const {
    handleSubmit,
    formState: { errors },
  } = formHook;

  const onCancel = async () => {
    navigate(-1);
  };
  const onSubmit = async (data: any) => {
    const response = await post("SaveUserProfile", data);
    if (response.success) Notify("Ändringarna har sparats", "success");
    else Notify("Ändringarna kunde inte sparas - " + response.message, "error");
  };

  const values = formHook.getValues() as any;
  const roles = (values?.permissions ? values.permissions.map((r: string) => getRoleName(r)) : []).join(", ");
  return (
    <>
      <div className="row d-flex align-items-center pb-4 ps-1 pe-3">
        <div className="col-8 fs-4 fw-bold">Min profil</div>

        <div className="col-4 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              navigate("../ChangePassword");
            }}
            disabled={!globalData?.user?.isPrimaryCustomer}
          >
            Byt lösenord
          </button>
        </div>

        <div className="col-4 d-flex justify-content-end"></div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="ModuleConfiguratorForm">
        <div className="ps-1 pe-3" style={{ minHeight: "300px", overflow: "auto" }}>
          <Card>
            <Card.Header>Användarinformation</Card.Header>
            <Card.Body>
              <div className="row ml-0">
                <div className="col-lg-6">
                  <StaticBox label="Användarnamn" text={values?.email}></StaticBox>
                </div>
                <div className="col-lg-6">
                  <TextEditor label="Telefonnummer" fieldName={"phoneNumber"} formHook={formHook as any}></TextEditor>
                </div>
              </div>
              <div className="row ml-0">
                <div className="col-lg-12">
                  <StaticBox label="Rättigheter" text={roles}></StaticBox>
                </div>
              </div>
            </Card.Body>
          </Card>

          <Card className="mt-4 mb-4">
            <Card.Header>Kundinformation {globalData?.user?.isPrimaryCustomer ? "(Primärkonto)" : "(Sekundärkonto)"}</Card.Header>
            <Card.Body>
              <div className="row ml-0">
                <div className="col-lg-6">
                  <StaticBox label="Kundnamn" text={values?.customerName}></StaticBox>
                </div>
                <div className="col-lg-6">
                  <StaticBox label="Kundnummer" text={values?.customerNumber}></StaticBox>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <div className="flex-grow-1">
            <ValidationSummaryMessages errors={errors} />
          </div>
          <div style={{ paddingRight: 12, paddingLeft: 4 }}>
            <button type="button" className="btn btn-secondary ms-2" onClick={onCancel}>
              Avbryt
            </button>
            <button type="submit" className="btn btn-primary ms-2">
              Spara
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default UserProfile;
